import React from "react";
import {Container, Row, Spinner} from "react-bootstrap";

/**
 * The Loader component displays a spinner while content is being loaded.
 *
 * @return {React.Component} The React component displaying the loader spinner.
 */
const Loader = () => (
    <Container fluid className="vh-50 d-flex">
        <Row className="justify-content-center align-self-center w-100 text-center">
            <Spinner animation="border"/>
        </Row>
    </Container>
);

export default Loader;
